__webpack_require__.p = "/workshop/_next/";